export default "__VITE_ASSET__D_$qkR5A__"